/**
 * Finance payment + budget status — API SCREAMING_SNAKE with Title Case display.
 */

import { createStatusHelpers } from "./statusHelpers";

export const PAYMENT_STATUS = {
  NOT_DUE: "NOT_DUE",
  DUE: "DUE",
  INVOICED: "INVOICED",
  PAID: "PAID",
} as const;

export type PaymentStatus =
  (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const PAYMENT_STATUS_DISPLAY: Record<PaymentStatus, string> = {
  [PAYMENT_STATUS.NOT_DUE]: "Not Due",
  [PAYMENT_STATUS.DUE]: "Due",
  [PAYMENT_STATUS.INVOICED]: "Invoiced",
  [PAYMENT_STATUS.PAID]: "Paid",
};

const paymentHelpers = createStatusHelpers(
  PAYMENT_STATUS,
  PAYMENT_STATUS.NOT_DUE,
  {
    "Not Due": PAYMENT_STATUS.NOT_DUE,
    Due: PAYMENT_STATUS.DUE,
    Invoiced: PAYMENT_STATUS.INVOICED,
    Paid: PAYMENT_STATUS.PAID,
  },
);

export const PAYMENT_STATUS_VALUES = paymentHelpers.VALUES;
export const tryNormalizePaymentStatus = paymentHelpers.tryNormalize;
export const normalizePaymentStatus = paymentHelpers.normalize;
export const isPaymentStatus = paymentHelpers.isStatus;
export const isAnyPaymentStatus = paymentHelpers.isAnyStatus;

export const BUDGET_STATUS = {
  ON_TRACK: "ON_TRACK",
  OVERSPENT: "OVERSPENT",
} as const;

export type BudgetStatus = (typeof BUDGET_STATUS)[keyof typeof BUDGET_STATUS];

const budgetHelpers = createStatusHelpers(
  BUDGET_STATUS,
  BUDGET_STATUS.ON_TRACK,
);

export const BUDGET_STATUS_VALUES = budgetHelpers.VALUES;
export const tryNormalizeBudgetStatus = budgetHelpers.tryNormalize;
export const normalizeBudgetStatus = budgetHelpers.normalize;
export const isBudgetStatus = budgetHelpers.isStatus;
export const isAnyBudgetStatus = budgetHelpers.isAnyStatus;
